<template>
  <md-card
    @mouseleave.native="onMouseLeave"
    :data-count="hoverCount"
    class="md-card-chart"
  >
    <md-card-header
      @mouseenter.native="onMouseOver"
      :data-header-animation="headerAnimation"
      :class="[
        { hovered: imgHovered },
        { hinge: headerDown },
        { fadeInDown: fixedHeader },
        { animated: true },
        { [getClass(backgroundColor)]: true },
        { 'md-card-header-text': HeaderText },
        { 'md-card-header-icon': HeaderIcon },
      ]"
    >
      <div v-if="chartInsideHeader" :id="chartId" class="ct-chart" ></div>
      <slot name="chartInsideHeader"></slot>
    </md-card-header>

    <md-card-content
      :style="
        chartOptions.height
          ? { height: chartOptions.height + 'px', marginBottom: '20px' }
          : ''
      "
      :id="isChart ? chartId : ''"
      :class="classNameComponent"
    >
      <chartist
        v-if="chartInsideContent"
        :type="chartType"
        :data="chartData"
        :options="chartOptions"
        :event-handlers="eventHandlers"
      >
      </chartist>
      <div
        class="md-card-action-buttons text-center"
        v-if="headerAnimation === 'true'"
      >
        <md-button
          class="md-danger md-simple fix-broken-card"
          @click="fixHeader"
          v-if="headerDown"
        >
          <slot name="fixed-button"></slot> Fix Header!
        </md-button>
        <slot name="first-button"></slot>
        <slot name="second-button"></slot>
        <slot name="third-button"></slot>
      </div>
      <slot name="content"></slot>
    </md-card-content>

    <md-card-actions md-alignment="left" v-if="!noFooter">
      <slot name="footer"></slot>
    </md-card-actions>
  </md-card>
</template>

<script>
export default {
  name: 'chart-card',
  props: {
    classNameComponent: String,
    HeaderText: Boolean,
    HeaderIcon: Boolean,
    noFooter: Boolean,
    chartInsideContent: Boolean,
    chartInsideHeader: Boolean,
    chartType: {
      type: String,
      default: 'Line' // Line | Pie | Bar
    },
    headerAnimation: {
      type: String,
      default: 'true'
    },
    chartOptions: {
      type: Object,
      default: () => {
        return {}
      }
    },
    chartResponsiveOptions: {
      type: Array,
      default: () => {
        return []
      }
    },
    chartAnimation: {
      type: Array,
      default: () => {
        return []
      }
    },
    chartData: {
      type: Object,
      default: () => {
        return {
          labels: [],
          series: []
        }
      }
    },
    backgroundColor: {
      type: String,
      default: ''
    },
    isChart: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      hoverCount: 0,
      imgHovered: false,
      fixedHeader: false,
      chartId: 'no-id',
      tooltipId: 'no-id',
      eventHandlers: []
    }
  },
  computed: {
    headerDown () {
      return this.hoverCount > 15
    }
  },
  methods: {
    headerBack: function () {
      this.fixedHeader = false
    },
    fixHeader: function () {
      this.hoverCount = 0
      this.fixedHeader = true

      setTimeout(this.headerBack, 480)
    },
    onMouseOver: function () {
      if (this.headerAnimation === 'true') {
        this.imgHovered = true
        this.hoverCount++
      }
    },
    onMouseLeave: function () {
      if (this.headerAnimation === 'true') {
        this.imgHovered = false
      }
    },

    getClass: function (backgroundColor) {
      return 'md-card-header-' + backgroundColor + ''
    },
    /***
     * Initializes the chart by merging the chart options sent via props and the default chart options
     */
    initChart (Chartist) {
      var chartIdQuery = `#${this.chartId}`
      Chartist[this.chartType](
        chartIdQuery,
        this.chartData,
        this.chartOptions,
        this.chartAnimation
      )
    },
    /***
     * Assigns a random id to the chart
     */
    updateChartId () {
      var currentTime = new Date().getTime().toString()
      var randomInt = this.getRandomInt(0, currentTime)
      this.chartId = `div_${randomInt}`
    },
    getRandomInt (min, max) {
      return Math.floor(Math.random() * (max - min + 1)) + min
    },
    onClickBar (context) {
      this.$emit('onClickBar', context)
    },
    removeEventListeners () {
      this.$nextTick(() => {
        const chartElement = document.querySelector(`#${this.chartId}`)
        if (chartElement) {
          const events = ['mouseover', 'mouseout', 'mouseleave', 'mousemove', 'resize']

          events.forEach(event => {
            chartElement.removeEventListener(event, this[event])
          })

          const tooltipElement = document.querySelector(`#${this.tooltipId}`)
          if (tooltipElement) {
            events.forEach(event => {
              tooltipElement.removeEventListener(event, this[event])
            })
            tooltipElement.removeEventListener('click', this.onClickBar)
          }
        }
      })
    }
  },
  mounted () {
    this.updateChartId()
    this.$nextTick(() => {
      /* eslint-disable */

      const chartId = this.chartId
      requestAnimationFrame(() => {
        $(function() {
          const horizontalLabels = $(`#${chartId}`).children().find('.customLabel.ct-horizontal.ct-end')
          if (horizontalLabels.length > 70) {
            horizontalLabels.addClass('transformLabel-xs')
          } else if (horizontalLabels.length > 20) {
            horizontalLabels.addClass('transformLabel')
          }
          $(`#${chartId}`).children().find('.chartist-tooltip').attr('id', 'tooltip_' + chartId)
          $(`#${chartId}`).children().find('.chartist-tooltip').hide();
          if ($(`#${chartId}`).find('.ct-chart-bar').length) {
            $(`#${chartId}`).on('mouseover', '.ct-bar', () => {
              $(`#tooltip_${chartId}`).show()
            })
            $(`#${chartId}`).on('mouseout', '.ct-bar', () => {
              $(`#tooltip_${chartId}`).hide()
            })
          } else if ($(`#${chartId}`).find('.ct-chart-line').length) {
            $(`#${chartId}`).on('mouseover', '.ct-series', () => {
              $(`#tooltip_${chartId}`).show()
            })
            $(`#${chartId}`).on('mouseout', '.ct-series', () => {
              $(`#tooltip_${chartId}`).hide()
            })
          } else {
            $(`#${chartId}`).hover(() => {
              $(`#tooltip_${chartId}`).show()
            }, () => {
              $(`#tooltip_${chartId}`).hide()
            })
          }
        })
      })
    })

    this.eventHandlers = [
      {
        event: 'draw',
        fn: context => {
          if (context.type === 'bar') {
            context.element._node.onclick = event => this.onClickBar(context)
          }
        }
      }
    ]
  },
  beforeDestroy () {
    this.removeEventListeners()
  }
}
</script>

<style>
.chartist-tooltip {
  pointer-events: none;
  will-change: contents;
  position: absolute;
  margin-top: 10px;
  font-family: "Roboto", "Helvetica", "Arial", sans-serif;
  text-align: center;
  background: rgba(0, 0, 0, 0.6);
  color: white;
  padding: 10px 10px;
  border-radius: 5px;
  z-index: 99999;
  -webkit-box-shadow: 2px 2px 15px 3px rgba(0,0,0,0.2);
  -moz-box-shadow: 2px 2px 15px 3px rgba(0,0,0,0.2);
  box-shadow: 2px 2px 15px 3px rgba(0,0,0,0.2);
  transition: 0.5s;
}

.ct-square {
  will-change: contents;
  height: 100%;
}
.displayNone {
  display: none !important;
}
.ct-series-f .ct-point, .ct-series-f .ct-line, .ct-series-f .ct-bar, .ct-series-f .ct-slice-donut {
  stroke: #ea4c89!important;
}
.ct-series-g .ct-point, .ct-series-g .ct-line, .ct-series-g .ct-bar, .ct-series-g .ct-slice-donut {
  stroke: #3c4858!important;
}

.ct-series-a .ct-slice-pie, .ct-series-a .ct-area {
    fill: #A8DCFF !important;
    opacity: 0.6;
}

.ct-series-a .ct-label{
   stroke: #36A1EB;
   stroke-width: 1px;
}
.ct-series-a .ct-line {
  stroke: #8ED2FF !important;
  stroke-width: 1px;
}
.ct-series-a .ct-point {
  stroke: #36A1EB !important;
  stroke-width: 4px;
  stroke-linecap: round;
}

.ct-series-b .ct-slice-pie, .ct-series-b .ct-area {
    fill: #3245B1  !important;
    opacity: 0.8;
}

.ct-series-b .ct-label{
   stroke: #3245B1 !important;
   stroke-width: 1px;
}
.ct-series-b .ct-line {
  stroke: #3245B1 !important;
  stroke-width: 1px;
}

.ct-series-b .ct-bar {
  stroke: #3245B1 !important;
}
.ct-series-b .ct-point {
  stroke: #1E2290 !important;
  stroke-width: 4px;
  stroke-linecap: round;
}

.ct-chart-line, .ct-chart-bar {
  overflow: visible !important;
}

.ct-labels .customLabel.ct-horizontal.ct-end.transformLabel {
  font-size: 10px;
  writing-mode: vertical-rl;
  white-space: nowrap;
  transform: rotate(-50deg);
}

.ct-labels .customLabel.ct-horizontal.ct-end.transformLabel-xs {
  font-size: 9px;
  writing-mode: vertical-rl;
  white-space: nowrap;
  transform: rotate(-20deg);
}
</style>